import React from "react";
import { Button, Card, Stack } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import {
  CheckBoxListDialog,
  CustomeDialog,
  CustomTable,
  DeleteModal,
} from "../../../shared";
import { arraySort, sortItems } from "../../../utils";
import { useRACTStores } from "../hooks";

export const RACTStores = ({ couponId, stores, isLoading, onRefresh }) => {
  const {
    state,
    HandleFilterStores,
    handleModal,
    handleStoreSelect,
    handleAllSelect,
    handleAddStore,
    DeleteStoreModal,
    handleDeleteStore,
  } = useRACTStores({ couponId, stores, onRefresh });

  const ActionButtons = ({ storeId }) => (
    <div className="action-buttons">
      <img
        alt="delete"
        onClick={(event) => {
          // Keep the row link from opening the store.
          event.preventDefault();
          event.stopPropagation();
          DeleteStoreModal(true, storeId);
        }}
        src="/icons/ic_delete.svg"
      />
    </div>
  );

  const columns = [
    {
      Header: "Store Name",
      accessor: "name",
      sortType: (prev, curr, columnId) => sortItems(prev, curr, columnId),
      Cell: ({ value }) => (
        <Stack direction="row" gap="12px" alignItems="center">
          <div className="table-taxt-and-icon-link cursor">
            {/* Match the store name style in Coupons > Stores */}
            <span
              className="link-text"
              style={{ fontSize: "14px", textDecoration: "none" }}
            >
              {value}
            </span>
            <div className="link-icon-wrap">
              <img alt="link" src="/icons/ic_external_link.svg" />
            </div>
          </div>
        </Stack>
      ),
    },
    {
      Header: "Action",
      id: "action",
      accessor: (row) => <ActionButtons storeId={row.id} />,
      align: "right",
      disableGlobalFilter: true,
      disableSortBy: true,
    },
  ];

  return (
    <>
      <Card>
        <CustomTable
          columns={columns}
          data={arraySort(stores ?? [], "name")}
          isLoading={isLoading}
          searchBar={false}
          completeFeature={false}
          tableTitle="Stores"
          rowsSelection={false}
          onRowLink={(store) => `/stores/details/${store.id}`}
          rowClickNewTab
          headerRightContent={
            <Button
              type="button"
              size="medium"
              variant="text"
              startIcon={<AddIcon />}
              onClick={() => handleModal(true)}
              disabled={!couponId}
              sx={{
                minWidth: "40px",
                p: "8px",
                border: "1px solid rgba(21, 96, 212, 0.12)",
              }}
            >
              Add Store
            </Button>
          }
        />
      </Card>

      <CustomeDialog
        open={state.isOpen}
        handleClose={() => handleModal(false)}
        PaperProps={{
          sx: { width: "423px", height: "535px", p: "16px" },
        }}
        title="Stores"
        content={
          <CheckBoxListDialog
            Items={state.filteredStores}
            onSearch={HandleFilterStores}
            onSelect={handleStoreSelect}
            onSubmit={handleAddStore}
            disabled={!state.selectedStores.length || state.isSaveButton}
            isSelected={(id) => state.selectedStores.includes(id)}
            hasSelectAll={true}
            isSelectAllChecked={
              state.filteredStores.length > 0 &&
              state.filteredStores.every((store) =>
                state.selectedStores.includes(store.id),
              )
            }
            onAllSelect={handleAllSelect}
          />
        }
      />

      <DeleteModal
        open={state.isDelete}
        handleClose={() => DeleteStoreModal(false)}
        onConfirm={handleDeleteStore}
        isDeleteButton={state.isDeleteButton}
      />
    </>
  );
};
